import { Component, OnInit } from '@angular/core';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { MaeUsuarioService } from 'src/app/service/mae-usuario.service';
import { MaeConstanciaService } from 'src/app/service/mae-constancia.service';
import { GlobalVariablesService } from 'src/app/service/global-variables.service';
import { MaeCorreoService } from 'src/app/service/mae-correo.service';
import { MaeProcesoService } from 'src/app/service/mae-proceso.service';
import { Response_dml_bean } from 'src/app/model/response-dml';

import { MaeCorreoM} from 'src/app/model/mae-correo-bean';
import { MaeUsuarioM,MaeUsuarioE } from 'src/app/model/mae-usuario-bean';
import { MaeConstanciaM } from 'src/app/model/mae-constancia-bean';
import { MatDialog } from "@angular/material/dialog";
import { ConfirmarsionoComponent } from 'src/app/comunes/confirmarsiono/confirmarsiono.component';

@Component({
  selector: 'app-correo-prueba',
  templateUrl: './correo-prueba.component.html',
  styleUrls: ['./correo-prueba.component.scss']
})
export class CorreoPruebaComponent implements OnInit {

  constructor(
    public  modalRefUsuarioDml: MDBModalRef,
    private utilitarioService:UtilitarioService,
    private maeConstanciaService:MaeConstanciaService,
    private maeUsuarioService:MaeUsuarioService,
    private maeProcesoService:MaeProcesoService,
    private globalVariablesService: GlobalVariablesService,
    private maeCorreoService:MaeCorreoService,
    private dialogo: MatDialog,
  ) { }

  //variables enviado desde el padre
  x_asunto:String;

  maeCorreoM = new MaeCorreoM();

  maeUsuarioE = new MaeUsuarioE();
  cboEntidad:String = "";


  listConstancias= new Array<MaeConstanciaM>();
  listConstanciasFil:Observable<MaeConstanciaM[]>;

  /*listConvenio= new Array<MaeDocumentoComboM>();
  listConvenioFil: Observable<MaeDocumentoComboM[]>;*/
  myControl = new FormControl();

  ngOnInit(): void {

    this.cargarDatoInicial();

  }

  cargarDatoInicial(){
    this.utilitarioService.loading = true;

    const cargarConvenio = this.maeConstanciaService.getfind("19","*","0").toPromise()
    .then(result => {
      this.listConstancias = result;

      this.listConstanciasFil = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this.onfilter(value))
      );
    });

    const cargarUsuario = this.maeUsuarioService.getUser(this.globalVariablesService.getC_usuario(),"1").toPromise()
    .then(result => {
      this.maeUsuarioE = result[0];
    });
    Promise.all([cargarConvenio,cargarUsuario])
      .then(response => {
        this.utilitarioService.loading = false;
      })
    .catch(error => console.log(`Error in executing ${error}`)
    );

  }
  onEnviar()
  {
    if (this.validarFormulario()==false){
      return false;
    }

    this.utilitarioService.loading=true;


    this.dialogo.open(ConfirmarsionoComponent, {
      data: { mensaje: 'Se realizara el envio de correo de prueba sin archivo adjunto, ¿Desea continuar?.'},
      width: '550px'
    })
    .afterClosed()
    .subscribe((confirmado: Boolean) => {
        if (confirmado) {

          this.utilitarioService.loading = true;

        this.maeProcesoService.enviarcorreoprueba(this.cboEntidad.toString(),this.globalVariablesService.getC_usuario()).subscribe(
          result=>{

          if (result.codigoRespuestaServicio=="1")
          {
            this.utilitarioService.toastrSuccess(result.mensaje);
            this.onClosemodal();
          }else{
            this.utilitarioService.toastrInfo(result.mensaje);
          };

          this.utilitarioService.loading = false;
        });

      } else {
        return;
      }
    });
  }
  validarFormulario() : Boolean{
    //valida formulario
    if (this.globalVariablesService.getC_usuario.toString()==null){
      this.utilitarioService.toastrError("Su session ha culminado, ingrese nuevamente al sistema.");
      return false;
    }

    if (this.cboEntidad=='' || this.cboEntidad==null){
      this.utilitarioService.toastrError("Seleccione el curso para generar el correo de prueba.");
      return false;
    }

    return true;
  }
  onSelected(option: MaeConstanciaM) {

    if(option==null || option==undefined){
      this.cboEntidad = "";
    }else{
      this.cboEntidad = String(option.c_constancia);
    }

  }
  onfilter(value: string){
    const filterValue = value.toLowerCase();
    return this.listConstancias.filter(option => option.x_curso.toLowerCase().includes(filterValue));
  }
  onClosemodal(){
    this.modalRefUsuarioDml.hide();
  }
}
